import axios from "axios";
import i18n from './index';
export const setLanguage =  (langCode) => {
  return new Promise(resolve => {
    axios.get('/official/outer/international/frontLanguageFiles', { responseType: 'blob' }).then(res => {
      const reader = new FileReader();
      reader.readAsText(res.data);
      reader.onload = e => {
        const data = JSON.parse(e.target.result);
        i18n.locale = langCode;
        i18n.mergeLocaleMessage(langCode, data);
        document.title = i18n.t('才汇链科技（深圳）有限公司');
        resolve();
      };
    });
  });
}


// WEBPACK FOOTER //
// ./src/lang/switchLanuage.js